import Styles from './AvatarsStack.module.scss'

import { AvatarsStackProps } from './Types'
import { fill } from 'lodash'
import Avatar from 'common/Avatar/Avatar'
import { getInitials } from 'utils'
import { Dropdown, Menu } from 'antd'

const AvatarsStack = ({ avatars, visibleCount, size, strokeColor }: AvatarsStackProps) => {
  const visibleAvatars = avatars.slice(0, visibleCount)
  const hiddenAvatars = avatars.slice(visibleCount, avatars.length)

  const strokeCount = visibleAvatars.length + (hiddenAvatars.length > 0 ? 1 : 0)
  const strokeArray = fill(new Array(strokeCount), null)

  const stroke = (
    <div className={Styles.strokeContainer}>
      {strokeArray.map((_, i) => (
        <div
          key={`stroke-${i}`}
          className={Styles.stroke}
          style={{
            background: strokeColor,
            width: size + 8,
            height: size + 8,
            marginLeft: -8,
          }}
        />
      ))}
    </div>
  )

  const dropdownOverlay = (
    <Menu>
      {hiddenAvatars.map((avatar, i) => (
        <Menu.Item key={`${avatar.label}-${i}`} className={Styles.dropdownItem}>
          <Avatar size={size} label={getInitials(avatar.label)} url={avatar.url} />
          <div className={Styles.dropdownName}>{avatar.label}</div>
        </Menu.Item>
      ))}
    </Menu>
  )

  return (
    <div className={Styles.root}>
      {strokeColor && stroke}
      {hiddenAvatars.length > 0 && (
        <Dropdown overlay={dropdownOverlay} placement="bottomCenter">
          <div className={Styles.stacked}>
            <Avatar label={`+${hiddenAvatars.length}`} size={size} />
          </div>
        </Dropdown>
      )}
      {visibleAvatars.map((avatar, i) => (
        <div key={`${avatar.label}-${i}`} className={Styles.stacked}>
          <Avatar size={size} label={getInitials(avatar.label)} url={avatar.url} />
        </div>
      ))}
    </div>
  )
}

export { AvatarsStack }
